import { groupDigits } from "web_myplann/Shared/Utils/groupDigits";

export const formatPhoneNumber = (phone: string | null | undefined): string => {
	if (!phone) return "";

	const compact = phone.replace(/\s+/g, "").replace(/^00/, "+");

	if (!/^\+?\d+$/.test(compact)) return phone.trim();

	return groupDigits(compact, " ");
};
